import React, {useState, useEffect} from 'react';
import {ThemeList} from './ThemeList';
import Popover from 'react-tiny-popover';
import { basename } from '../../../utils';

export const Header = () => {
    const [municipality, setMunicipality] = useState(null);
    const [isThemesOpen, setThemesOpen] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            let mun = await (await fetch(`./municipalities/${basename}.json`)).json()
            setMunicipality(mun)
        }

        fetchData();
    }, []);


    const onThemeClicked = () => {
        //history.push('/settings');
        setThemesOpen(!isThemesOpen)
        if (!isThemesOpen){
            let items = window.document.querySelectorAll('.theme-item')
            if (items.length > 0){
                items[0].focus()
            }
        }
    }

    const onKeyDownHandle = (e, func) => {
        if(e.keyCode === 13 || e.key === 'Enter'){
            func()
        }
    }

    return(
        <div className='header'>
            <div className='toolbar'>
                    <Popover
                        isOpen={isThemesOpen}
                        onClickOutside={ () => setThemesOpen(false)}
                        position={'bottom'} // preferred position
                        content={<ThemeList setThemesOpen = {setThemesOpen}/>}
                        align={'start'}
                    >
                        <span
                            id="contrast1"
                            onClick={()=> onThemeClicked()}
                            onKeyDown = { (e) => onKeyDownHandle(e, onThemeClicked) }
                            tabIndex = {0}>
                                Contrast</span>
                    </Popover>
                {/* <div className='contrast'>Contrast</div> */}
            </div>

            <div className="header__main">

                <img className = 'icon-city' src={`./municipalities/${basename}.png`} alt="city logo" />

                {municipality &&
                    <div className = 'city-title'>{municipality.title}</div>
                }
            </div>
        </div>
    )
}
